import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderModel } from '../../model/order.model';
import { OrderService } from '../../order.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AppConstants } from 'src/app/common/app.constants';
import { UserInfoModel } from 'src/app/common/models/user-info.model';

@Component({
  selector: 'app-email-dialog',
  standalone: false,

  templateUrl: './email-dialog.component.html',
  styleUrl: './email-dialog.component.scss'
})
export class EmailDialogComponent {
  editForm!: FormGroup;
  orderInfo: OrderModel;
  user: UserInfoModel | undefined;
  isSending = false;

  ngOnInit(): void {

    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    console.log(this.user)
  }
  constructor(
    private builder: FormBuilder,
    private dialogRef: MatDialogRef<EmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public item: {
      order_id: string;
      total_amount_paid: number;
      email: string;
    },
    private orderService: OrderService,
    private snackBarService: SnackBarService
  ) {
    console.log('Dialog data:', item);

    this.orderInfo = JSON.parse(JSON.stringify(item));
    this.buildForm();
  }

  buildForm(): void {
    this.editForm = this.builder.group({
      order_id: [this.orderInfo.order_id || '',],
      total_amount_paid: [`$${(this.orderInfo?.total_amount_paid ?? 0).toFixed(2)}`],
      email: [this.orderInfo.email || '', [Validators.required, Validators.email]]
    },);
  }



  /**
 * On sendEmail
 * if the details are valid call the API to update the changes.
 */
  sendEmail(): void {
    this.isSending = true;
    if (this.editForm.valid) {
      const requestData = {
        email: this.editForm.get('email')?.value,
        order_id: this.orderInfo.order_id,
        shop_id: this.user?.shop_info.id
      };
      console.log('Dialog data:', requestData);
      this.orderService.sendEmail(requestData).subscribe({
        next: (response) => {
          if (response.status === 'SUCCESS') {
            this.isSending = false;

            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Mail Sent',
              message: 'Mail sent successfully.'
            });
            this.dialogRef.close();
          } else {
            this.snackBarService.openSnackBar({
              type: 'error',
              title: 'Failed to Send Email',
              message: response.message
            });
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.snackBarService.openSnackBar({
            type: 'error',
            title: 'Failed',
            message: 'An error occurred while sending email.'
          });
        }
      });

    }
    else{
      this.editForm.markAllAsTouched();
      this.isSending = false;
    }

  }




  /**
   * Close the dialog
   */
  cancel(): void {
    this.dialogRef.close();
  }
}
